import React from "react";
import { CheckIcon } from "../Elements";



const PaymentProviders = ({paymentProviders, selectedPaymentProvider, setSelected, disabled}) => {



    return <div className="Tabs is-icontabs is-desktop m2">
        <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between mb2">
            <label htmlFor="cardNumber-fieldset">
                <span className="Text Text-color--gray600 Text-fontSize--15 Text-fontWeight--500">
                    Ödeme Altyapısı
                </span>
            </label>
        </div>
        <div className="Tabs-Container">
            <div role="tablist" aria-orientation="horizontal" aria-label="Zahlungsmethoden" className="Tabs-TabList">

                {paymentProviders.map((item, index) => {
                    const isSelected = selectedPaymentProvider == item.vpid;

                    return (
                        <div role="presentation" key={"providers" + index} className={`Tabs-TabListItemContainer ${isSelected ? "Tabs-TabListItemContainer--is-selected" : ""}`}>
                            <button disabled={disabled} className={`Tabs-TabListItem ${isSelected ? "Tabs-TabListItem--is-selected" : ""}`} id="card-tab" data-testid="card-tab-button" role="tab" type="button"
                                aria-controls="card-tab-panel" aria-label="Mit Karte zahlen" aria-selected="true" tabIndex="0" title="Karte"
                                onClick={() => {
                                    // setFormValues({
                                    //     ...formValues,
                                    //     paymentProvider: item.vpid
                                    // });
                                    setSelected(item.vpid);
                                }}
                            >

                                <div className="Tabs-TabListItemContent">
                                    <div className="Tabs-TabListPaymentMethod">
                                        <div className="Tabs-TabListPaymentIcon justify-content-row">
                                            <img src={"/webapitest/" + item.bankImagePath} alt=""
                                             className="Icon Icon--xlg-2" style={{
                                                filter:isSelected ?"none" : "grayscale(25%)" 
                                             }} />
                                            {isSelected ? (
                                                <CheckIcon size={15} className={"small-check-icon"} />
                                            ) : null}
                                        </div>
                                        <div className="Tabs-TabListPaymentLabel" data-text="Karte">{item.vpdisplayname || item.bankname}</div>

                                    </div>

                                </div>
                            </button>
                        </div>
                    );
                })}

            </div>
        </div>
    </div>
}
export default PaymentProviders;